<main class="fc-content-wrapper">
  <section class="fc-content">
    <mat-tab-group
      [(selectedIndex)]="selectedTabIndex"
      [dynamicHeight]="true"
      [dynamicHeight]="true"
      [disableRipple]="true"
      class="fc-tab-group"
    >
      <mat-tab disabled="true">
        <ng-template mat-tab-label>
          <div class="fc-logo"></div>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="fc-tab-title fc-tab-title__main" (click)="onMainClick()"
            ><mat-icon class="menu-icon">home</mat-icon>Main</span
          >
        </ng-template>
        <div class="main-page">
          <app-main-component
            *ngIf="listOfMachinesFromApi && machineStates && machineEnergy"
            [machinesFromApi]="listOfMachinesFromApi"
            [machineStates]="machineStates"
            [machineEnergy]="machineEnergy"
          ></app-main-component>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="fc-tab-title fc-tab-title__machine"
            ><mat-icon class="menu-icon">assessment</mat-icon>Machine</span
          >
        </ng-template>
        <div class="machines-page">
          <app-machines-component
            *ngIf="listOfMachinesFromApi.length"
            [listOfMachinesFromApi]="listOfMachinesFromApi"
          ></app-machines-component>
        </div>
      </mat-tab>
      <mat-tab *appFeatureEnabled="'FEAT_DEPARTMENT'">
        <ng-template mat-tab-label>
          <span class="fc-tab-title fc-tab-title__department"
            ><mat-icon class="menu-icon">group_work</mat-icon>Department</span
          >
        </ng-template>
        <div class="departments-page">
          <app-departments-component
            *ngIf="listOfDepartmentsFromApi.length"
            [listOfDepartmentsFromApi]="listOfDepartmentsFromApi"
          ></app-departments-component>
        </div>
      </mat-tab>
      <mat-tab *appFeatureEnabled="'FEAT_JOB_ORDER'">
        <ng-template mat-tab-label>
          <span class="fc-tab-title fc-tab-title__job"
            ><mat-icon class="menu-icon">event</mat-icon>Job</span
          >
        </ng-template>
        <div class="job-orders-page">
          <app-job-orders-component></app-job-orders-component>
        </div>
      </mat-tab>
      <mat-tab *appFeatureEnabled="'FEAT_DATA_STUDIO_REPORT'">
        <ng-template mat-tab-label>
          <span class="fc-tab-title fc-tab-title__reports">Reports</span>
        </ng-template>
        <div class="reports-page">
          <app-data-studio-report-component></app-data-studio-report-component>
        </div>
      </mat-tab>
      <mat-tab *appHasRole="['ROLE_ROOT', 'ROLE_ADMIN']">
        <ng-template mat-tab-label>
          <span class="fc-tab-title fc-tab-title__settings"
            ><mat-icon class="menu-icon">settings</mat-icon>Settings</span
          >
        </ng-template>
        <div class="settings-page">
          <app-settings-component
            (machinesAddedOrUpdated)="onMachinesAddedOrUpdated()"
          >
          </app-settings-component>
        </div>
      </mat-tab>
      <mat-tab *appFeatureEnabled="'FEAT_FABRICODE_PLUS'" disabled="true">
        <ng-template mat-tab-label>
          <a
            href="{{ fabricodePlusPath }}/#/?autologin-payload={{
              encodedLoggedUser
            }}"
            class="fc-tab-title fc-tab-title__fabricodeplus"
            target="_blank"
            ><mat-icon class="menu-icon">link</mat-icon>Fabricode+
          </a>
        </ng-template>
      </mat-tab>
      <mat-tab disabled="true">
        <ng-template mat-tab-label>
          <a href="/login" class="fc-tab-title fc-tab-title__logout">
            <mat-icon class="menu-icon">logout</mat-icon>Logout</a
          >
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label><app-env-info></app-env-info></ng-template>
      </mat-tab>
      <mat-tab disabled="true">
        <ng-container *ngIf="customer$ | async as customer">
          <ng-template mat-tab-label>
            <span class="fc-tab-title">
              <mat-icon class="menu-icon" class="menu-icon"
                >perm_identity</mat-icon
              >{{ customer.name }}</span
            >
          </ng-template>
        </ng-container>
      </mat-tab>
    </mat-tab-group>
  </section>
  <section class="footer">
    <app-footer-component></app-footer-component>
  </section>
</main>
